export default __webpack_public_path__ + "static/media/linkedin-yellow.d7473617.svg";